import React, { useState } from "react";
import styled from "styled-components";
import {
  SelectForm,
  MainBlock,
  MiniBlock,
  MiniBlockOrderRows,
  MiniBlockOrderRowsCustom,
} from "../../../common/Buttons";
import PreviewComment from "./editModal/previewComment";
import { connect } from "react-redux";
import SubmitComment from "./editModal/submitComment";
import { editPayment } from "../../../../redux/Actions/paymentAction";
import {
  createNordrentOrderStatus,
  updateSerialNumber,
  updateSerialNumberState,
  clearErrors,
  postToRivile,
  postOrderShipping,
  updateOrderAddress,
  postOrderRow,
} from "../../../../redux/Actions/orderAction";
import {
  setCountriesOptions,
} from "../../../../redux/Actions/options_action";
import {
  addContract,
  updateContract,
  deleteContractItem,
  deleteContract,
  sendContractEmail,
  firstAddContract,
  firstDeleteContract,
  changeContractItems,
} from "../../../../redux/Actions/orderContractAction";
import { getDocumentType } from "../../../../redux/Actions/documentTypeAction";
import AdditionalServicesMain from "./editModal/AdditionalServices/AdditionalSerivcesMain";
import AttachOrderDocument from "./editModal/AttachOrderDocument/AttachOrderDocument";
import { SerialNumberBlock } from "../../../common/SerialNumberModal";
import Spinner from "../../../common/Spinner";
import { GrEdit, GrClose } from "react-icons/gr";
import ShippingAddressComponent from "./editModal/shippingAddress";
import BillingAddressComponent from "./editModal/billingAddress";
import OrderRowsComponent from "./editModal/order_row/order_rows";
import PaymentBlockComponent from "./editModal/Payments/payments_block";
import OrderTotalComponent from "./editModal/SmallComp/order_total";
import SmsSending from "./editModal/SmallComp/sms_sending";
import { antdMessageError, phonenumberValid } from "../../../../helpers/Utils";
import DeliveryComponent from "./delivery/delivery_block";
import SupplyComponent from "./editModal/SupplyComponent";
import StatusComponent from "./StatusComponent";
import LeasingComponent from "./LeasingComponent";
import ShippingComponent from "./ShippingComponent";
import {
  onChangeCheckBoxDeliveryGlobal,
  handleChangeOrdertypeGlobal,
  shipment_type_setter,
  shipmentAdditionalServicesAttributesParams,
  setCod,
  availableCountries,
  setCodAmount2,
  orderRowBuildWithParents,
  possibilityToAssignDeliveryAmount,
  onlyFiOrders,
} from "../../../../helpers/OrdersFunctionsGlobal";
import { shipment_types_options } from "../../../../helpers/GlobalOptions";
import { AiOutlineAlert, AiOutlineInfoCircle } from "react-icons/ai";
import { ClassicButtonOutline } from "../../ButtonWithLoading";
import { Bubble } from "../../../common/StyledComponents";
import ActionHistoryContent from "../../../orders/accepted_orders/features/action_history/ActionHistoryContent";
import AntdConfirm from "../../../../helpers/AntdConfirm";
import OrderRowProductSuppliers from "../../../orders/accepted_orders/features/OrderRowProductSuppliers";
import { OrderTaxFree } from "./";
import { OrderActivities, OrderDiscounts } from "./editModal";
import { setOrderInitialValue } from "../../../../utils/order";
import OrderRowsReturn from "./editModal/order_row/OrderRowsReturn";

class NordrentOrderShowModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      order_type: "dpd",
      delivery: "dpd_b2c",

      suppliers: undefined,
      weight: 1,
      pack: 1,
      carrying: false,
      order_return: false,
      sendingDocuments: false,
      deliveryTime: false,
      deliveryOnSaturday: false,
      delivery_same_day: false,
      cod: false,
      cod_amount: 0,
      who: "",
      deliveryTimeHours: ["", ""],
      shipping_loading: false,
      // suppliersItems: [],
      swap: false,
      lp_express_sizes: undefined,
      delivery_after_18: false,
      ignore_stock_check: false,

      shipping_address_edit: {},

      terminalSelected: undefined,
      // Collapse
      tableItemsCollapses: Array.isArray(
        JSON.parse(localStorage.getItem("itemsCollapse"))
      )
        ? JSON.parse(localStorage.getItem("itemsCollapse")).filter(
          (d) => !d.includes("_add")
        )
        : ["order_information"],
      //
      payments_col: false,
      payments_add_col: false,
      delivery_add_col: false,
      tax_free_col: false,

      // Uzsakymo info redagavimas
      billingAdr_action_edit: false,
      shippingAdr_action_edit: false,

      skip_labels: false,
      selectedCarrier: "sendDirectly",
      savedShippingAddress: null,
    };
  }

  componentDidMount() {
    this.props.clearErrors();
    this.startedPack(this.props.order);
    this.props.setCountriesOptions();
  }

  startedPack = (orderInfo) => {
    // Check carrying
    this.props.getDocumentType(orderInfo.order_shop_id);
    this.setState({
      ...setOrderInitialValue(orderInfo, {
        pickup_addresses: this.props.pickup_addresses,
        order_rows: this.props.order_rows,
      }),
    });
  };

  onChangeCarrier = (carrier) => {
    const { ordersShipmentsOver80Kg } = this.props;

    if (carrier === "sendDirectly") {
      this.setState({
        selectedCarrier: carrier,
        shipping_address_edit:
          this.state.savedShippingAddress || this.state.shipping_address_edit,
      });
    } else {
      this.setState({
        selectedCarrier: carrier,
        savedShippingAddress: this.state.shipping_address_edit,
        shipping_address_edit: {
          ...ordersShipmentsOver80Kg?.[carrier],
          firstname: ordersShipmentsOver80Kg?.[carrier]?.name,
          lastname: "",
          country_id: ordersShipmentsOver80Kg?.[carrier]?.country_id,
          street: ordersShipmentsOver80Kg?.[carrier]?.address,
        },
      });
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.order.cod !== this.props.order.cod ||
      prevProps.order.leasing_cod !== this.props.order.leasing_cod ||
      prevState.order_type !== this.state.order_type
    ) {
      this.setState({
        cod: setCod({
          cod: this.props.order.cod,
          leasing_cod: this.props.order.leasing_cod,
          shipment_type: this.state.order_type,
          payment_module: this.props.order.payment_module,
        }),
      });
    }

    if (
      prevState.cod !== this.state.cod ||
      prevProps.order_rows !== this.props.order_rows ||
      prevProps.or_quantity_manual !== this.props.or_quantity_manual ||
      prevProps.order.order_cart_rules !== this.props.order.order_cart_rules
    ) {
      const cod_amount = setCodAmount2({
        waiting_payments: this.props.order.waiting_payments,
        order_rows: this.props.order_rows,
        or_quantity_manual: this.props.or_quantity_manual,
        shipments: this.props.shipments,
        orderInfo: this.props.order,
        order_cart_rules: this.props.order.order_cart_rules,
      });
      this.setState({
        weight: this.countWeight(this.props.order_rows),
        cod_amount: cod_amount.price,
      });
    }
  }

  createShipping = () => {
    if (
      this.props.order.order_shop?.identifier == "TCH" &&
      this.state.order_type == "at_the_store" &&
      this.props.order_rows.filter((e) => e.selected).length == 0
    ) {
      return antdMessageError(
        "[TCH] Cannot be created without a product selected"
      );
    }
    this.setState({
      shipping_loading: true,
    });
    let orderVariables = {
      id_order: this.props.order.id_order,
      final_carrier: this.state.savedShippingAddress,
      shipment: {
        shipment_type: shipment_type_setter(
          this.state.order_type,
          this.state.delivery
        ),
        packets: this.state.pack,
        weight: this.state.weight,
        pickup_address_id: this.state.suppliers,
        skip_labels: this.state.skip_labels,
        ignore_stock_check: this.state.ignore_stock_check,
        shipment_address_attributes: {
          company: this.state.shipping_address_edit.company,
          name:
            this.state.shipping_address_edit.firstname +
            " " +
            this.state.shipping_address_edit.lastname,
          country_id: this.state.shipping_address_edit.country_id,
          address: this.state.shipping_address_edit.street,
          city: this.state.shipping_address_edit.city,
          postal_code: this.state.shipping_address_edit.postal_code,
          parcel_terminal_id: this.state.terminalSelected,
          phone: this.state.shipping_address_edit.phone?.trim(),
          email: this.state.shipping_address_edit.other,
          comment: this.state.shipping_address_edit.comment,
        },
        shipment_order_rows_attributes: this.props.order_rows
          .filter((e) => e.selected)
          .map((e) => ({
            quantity: this.props.or_quantity_manual[e.id] || +e?.quantity,
            title: e.product_name,
            price: e.unit_price_tax_incl,
            order_row_id: e.id,
          })),
        shipment_additional_services_attributes:
          shipmentAdditionalServicesAttributesParams({
            ...this.state,
            packets: this.state.pack,
            type: this.state.order_type,
            shipping_price: possibilityToAssignDeliveryAmount({
              shipments: this.props.shipments,
              orderInfo: this.props.order,
            }),
            cod_rules: setCodAmount2({
              waiting_payments: this.props.order.waiting_payments,
              order_rows: this.props.order_rows,
              or_quantity_manual: this.props.or_quantity_manual,
              shipments: this.props.shipments,
              orderInfo: this.props.order,
              order_cart_rules: this.props.order.order_cart_rules,
            }),
          }),
      },
    };
    const country_id =
      orderVariables.shipment.shipment_address_attributes?.country_id;
    if (!country_id) {
      return antdMessageError("Select the country");
    }

    const proceedWithShipping = () => {
      if (
        availableCountries(country_id, this.props.order.order_shop.country_id)
      ) {
        return this.createShippingApi(orderVariables);
      }
      AntdConfirm({
        title: (
          <span>
            Are you sure you want to ship to this country:{" "}
            <b>{this.state.shipping_address_edit?.country?.en_name}</b>?
          </span>
        ),
        onOk: () => this.createShippingApi(orderVariables),
        onCancel: () =>
          this.setState({
            shipping_loading: false,
          }),
      });
    };

    if (this.state.order_type === "zipasgo" && this.state.suppliers) {
      const supplierInfo = this.props.pickup_addresses.find(
        (pa) => pa.id === this.state.suppliers
      );
      AntdConfirm({
        title: (
          <span>
            Are you sure you want to create a shipment with <b>ZipasGo</b> courier from supplier{" "}
            <b>{supplierInfo?.label || this.state.suppliers}</b>?
          </span>
        ),
        onOk: () => proceedWithShipping(),
        onCancel: () =>
          this.setState({
            shipping_loading: false,
          }),
      });
      return;
    }

    proceedWithShipping();
  };

  createShippingApi = async (orderVariables) => {
    try {
      const res = await this.props.postOrderShipping(
        this.state.id,
        orderVariables,
        "Order"
      );
      if (res.success) {
        this.props.clearErrors();
      }
    } catch (err) {
      console.log("createShippingApi: ", err);
    } finally {
      this.setState({
        shipping_loading: false,
      });
    }
  };

  handleChangeText = (e, where) => {
    if (where == null) {
      this.setState({
        [e.target.name]: e.target.value,
      });
    } else {
      this.setState({
        [where]: {
          ...this.state[where],
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  countWeight = (items) => {
    const reducer = (accumulator, currentValue) => {
      if (
        typeof currentValue.product_info === "object" &&
        currentValue.product_info !== null
      ) {
        return accumulator + +currentValue.product_info.weight;
      } else {
        return accumulator + 0;
      }
    };

    return items.reduce(reducer, 0) || 1;
  };

  handleChangecollapseBlock = (item) => {
    const currentIndex = this.state.tableItemsCollapses.indexOf(item);
    const newChecked = [...this.state.tableItemsCollapses];
    if (currentIndex === -1) {
      newChecked.push(item);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      tableItemsCollapses: newChecked,
    });
    localStorage.setItem("itemsCollapse", JSON.stringify(newChecked));
  };

  collapseBlockActive = (name) => this.state.tableItemsCollapses.includes(name);

  updateOrderAddress = (action, dataObj) => {
    let params = {};
    delete dataObj.valid_phone;
    let objData = {
      ...dataObj,
      firstname: dataObj.firstname,
      lastname: dataObj.lastname,
      street: dataObj.street,
      city: dataObj.city,
      postal_code: dataObj.postal_code,
      phone: dataObj.phone,
      other: dataObj.other,
      country_id: dataObj.country_id,
      customer_id: dataObj.customer_id,
    };
    if (action == "billing") {
      params = {
        billing_address_attributes: {
          ...objData,
          company: dataObj.company,
          vat_code: dataObj.vat_code,
          company_code: dataObj.company_code,
        },
      };
      delete params.billing_address_attributes.country;
    } else if (action == "shipping") {
      params = {
        shipping_address_attributes: {
          ...objData,
        },
      };
      delete params.shipping_address_attributes.country;
    }

    this.props.updateOrderAddress(this.state.id, params).then((response) => {
      if (response.ok) {
        let changes = {};
        if (action == "billing") {
          changes = {
            billingAdr_action_edit: false,
          };
        } else if (action == "shipping") {
          changes = {
            shippingAdr_action_edit: false,
            shipping_address_edit: {
              ...this.state.shipping_address_edit,
              ...response.data.shipping_address,
            },
          };
        }
        this.setState({
          ...changes,
        });
      }
    });
  };

  paymentBlock = () => {
    this.props.editPayment({
      reference: "",
      payment_type: undefined,
      price: "",
    });
    this.handleChangecollapseBlock("payments_add_col");
  };

  updateShippingAddressTerminal = (shipping_address_edit) => {
    this.startedPack({
      ...this.props.order,
      shipping_address_edit,
    });
  };

  setSkipLabels = (value) => {
    this.setState({ skip_labels: value });
  };

  render() {
    const {
      documentType,
      order_histories,
      contracts,
      order_rows,
      shipments,
      order_documents,
      loading_order,
      order,
    } = this.props;

    const order_cart_rules = this.props.order.order_cart_rules;
    const order_type = this.state.order_type;
    const { billingAdr_action_edit, shippingAdr_action_edit } = this.state;
    if (loading_order) {
      return (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          <Spinner />
        </div>
      );
    }
    const order_rows_rebuild = orderRowBuildWithParents(order_rows);
    const disabled = onlyFiOrders(this.props.auth.user.id);
    const nordrentCommentOptions = (this.props.comments_state || []).filter(
      (option) =>
        option.comment_type === "comment_ka" &&
        option.name?.toLowerCase().includes("nordrent")
    ).map((option) => ({
      ...option,
      label: option.label || option.name,
      value: option.value || option.id,
    }));

    // Nordrent: only show comments / statuses that belong to nordrent
    const nordrentComments = (order.comments || []).filter((comment) =>
      comment.comment_state?.name?.toLowerCase().includes("nordrent")
    );
    const nordrentOrderHistories = (order_histories || []).filter((history) =>
      history.status?.title?.toLowerCase().includes("nordrent")
    );

    return (
      <div className="row">
        <div className="col-6">
          <Divs className="container-title-block">
            <MainBlock
              color={"#ffa800"}
              action={this.collapseBlockActive("order_information")}
              onChange={() =>
                this.handleChangecollapseBlock("order_information")
              }
            >
              Ordering information
            </MainBlock>
          </Divs>
          {this.collapseBlockActive("order_information") && (
            <Divs className="mt-3 mb-4">
              <>
                <div className="col-12 row" style={{ margin: 0 }}>
                  <Divs className="col-6" style={{ width: "50%" }}>
                    <div className="d-flex justify-content-between font-weight-bold mb-3">
                      <span>Delivery information</span>
                    </div>
                    <ShippingAddressComponent
                      module_name={order.carrier.module_name}
                      shippingAdr_action_edit={false}
                      UlElements={UlElements}
                      shipping_address={order.shipping_address}
                      updateOrderAddress={this.updateOrderAddress}
                      customer={order.customer}
                    />
                  </Divs>
                  <Divs
                    className="col-6"
                    style={{
                      width: "50%",
                      borderLeft: "1px solid #e3e3e3",
                    }}
                  >
                    <div className="d-flex justify-content-between font-weight-bold mb-3">
                      <span>Payer information</span>
                    </div>
                    <BillingAddressComponent
                      hideInvoice
                      disabled={disabled}
                      billingAdr_action_edit={false}
                      UlElements={UlElements}
                      billing_address={order.billing_address}
                      orderId={this.state.id}
                    />
                  </Divs>
                </div>
                <Divs className="mt-3 mb-2">
                  <OrderTotalComponent
                    total_price={order.total_price}
                    vat_code_pvm={order.is_without_vat}
                    total_discounts_tax_incl={order.total_discounts_tax_incl}
                    total_discounts={order.total_discounts}
                  />
                  <br />
                  {(order?.urgent ||
                    order?.status?.identifier == "finished") && (
                      <div
                        className={`d-flex justify-content-between align-items-center mb-3`}
                      >
                        {order?.urgent ? (
                          <>
                            <div className={"text-danger"}>
                              <AiOutlineInfoCircle
                                className="text-danger mr-2"
                                style={{ fontSize: 17 }}
                              />
                              Urgent order
                            </div>

                            <button
                              className="btn btn-sm btn-outline-danger d-flex justify-content-center align-items-center"
                              style={{
                                minWidth: "50px",
                                maxWidth: "150px",
                                height: "30px",
                              }}
                              onClick={() =>
                                this.props.updateOrderAddress(this.state.id, {
                                  urgent: !order?.urgent,
                                })
                              }
                            >
                              <AiOutlineAlert size={16} />
                              <span className="ml-2">Cancel URGENT</span>
                            </button>
                          </>
                        ) : (
                          <>
                            <div />
                            <ClassicButtonOutline
                              loading={false}
                              onClick={() =>
                                this.props.updateOrderAddress(this.state.id, {
                                  urgent: !order?.urgent,
                                })
                              }
                            >
                              <AiOutlineAlert size={16} />
                              <span className="ml-1">
                                {order?.urgent ? "Cancel" : "Set"} URGENT
                              </span>
                            </ClassicButtonOutline>
                          </>
                        )}
                      </div>
                    )}
                  {(!!this.state.shipping_address_edit.comment ||
                    !!order.remark) && (
                      <div
                        className={`d-flex justify-content-start align-items-center text-danger`}
                      >
                        <AiOutlineInfoCircle
                          className="text-danger mr-2"
                          style={{ fontSize: 17 }}
                        />{" "}
                        Note from client :{" "}
                        {this.state.shipping_address_edit.comment || order.remark}
                      </div>
                    )}
                </Divs>

                {/* Nordrent: Goods read-only — hides header edit pencil + per-row edit/delete/S-N */}
                <OrderRowsTab
                  action={this.collapseBlockActive("information_goods")}
                  onAction={() =>
                    this.handleChangecollapseBlock("information_goods")
                  }
                  disabled={true}
                  order={order}
                  order_rows={order_rows}
                  shipping_address_email={
                    this.state.shipping_address_edit.other
                  }
                />

                {!disabled &&
                  order_rows.some((some) => some.required_serial_number) && (
                    <>
                      <MiniBlock
                        color={"#ffcc69"}
                        action={this.collapseBlockActive("serial_number")}
                        onChange={() =>
                          this.handleChangecollapseBlock("serial_number")
                        }
                      >
                        Serial numbers
                      </MiniBlock>
                      {this.collapseBlockActive("serial_number") && (
                        <Divs>
                          <div className="col-12 bg-silver">
                            <SerialNumberBlock
                              orderID={this.state.id}
                              updateSerialNumber={this.props.updateSerialNumber}
                              updateSerialNumberState={
                                this.props.updateSerialNumberState
                              }
                              options={order_rows.filter(
                                (filt) => filt.required_serial_number
                              )}
                            />
                          </div>
                        </Divs>
                      )}
                    </>
                  )}
                <MiniBlock
                  color={"#ffcc69"}
                  action={this.collapseBlockActive("information_status")}
                  onChange={() =>
                    this.handleChangecollapseBlock("information_status")
                  }
                >
                  Status
                </MiniBlock>
                {this.collapseBlockActive("information_status") && (
                  <Divs>
                    <StatusComponent
                      nordrent
                      orderId={this.state.id}
                      avalaibleStatus={[]}
                      order_histories={nordrentOrderHistories}
                    />
                  </Divs>
                )}
                <React.Fragment>
                  <MiniBlockOrderRows
                    editAction={false}
                    color={"#ffcc69"}
                    action={this.collapseBlockActive("information_delivery")}
                    onChange={() =>
                      this.handleChangecollapseBlock("information_delivery")
                    }
                    goodsAddRow={this.collapseBlockActive("delivery_add_col")}
                    goodsAddRowClick={() =>
                      this.handleChangecollapseBlock("delivery_add_col")
                    }
                  >
                    Delivery
                  </MiniBlockOrderRows>
                  {this.collapseBlockActive("information_delivery") && (
                    <Divs>
                      <DeliveryComponent
                        order_rows={order_rows}
                        delivery_add_col={this.collapseBlockActive(
                          "delivery_add_col"
                        )}
                        carrier={order.carrier}
                        orderId={order.id}
                        total_shipping={order.total_shipping_tax_incl}
                        payment={order.payment}
                        nordrent
                        shipping_address={order.shipping_address}
                        updateShippingAddress={
                          this.updateShippingAddressTerminal
                        }
                        order_shop_id={order.order_shop_id}
                        cod={order.cod}
                      />
                    </Divs>
                  )}
                </React.Fragment>
              </>
            </Divs>
          )}
        </div>
        <div className="col-6">
          <Divs className="bg-silver">
            <MainBlock
              color={"#008aff"}
              action={this.collapseBlockActive("comment_col")}
              onChange={() => this.handleChangecollapseBlock("comment_col")}
            >
              Comments
            </MainBlock>
            {this.collapseBlockActive("comment_col") && (
              <div className="mb-4 mt-2">
                <MiniBlock
                  color={"#7ebff7"}
                  action={this.collapseBlockActive("ka_comment_col")}
                  onChange={() =>
                    this.handleChangecollapseBlock("ka_comment_col")
                  }
                >
                  KA comments
                </MiniBlock>
                {this.collapseBlockActive("ka_comment_col") && (
                  <div className="col-12">
                    <SubmitComment
                      orderId={this.state.id}
                      type="comment_ka"
                      options={nordrentCommentOptions}
                    />
                    <PreviewComment
                      comments={nordrentComments}
                      type="comment_ka"
                    />
                  </div>
                )}
              </div>
            )}
          </Divs>
        </div>
      </div>
    );
  }
}

const OrderRowsTab = ({
  action,
  onAction,
  disabled,
  order,
  order_rows,
  shipping_address_email,
}) => {
  const [recordType, setRecordType] = useState("order_rows");
  console.log({ order });
  return (
    <React.Fragment>
      <MiniBlockOrderRowsCustom
        editAction={!disabled && recordType.includes("order_rows")}
        color={"#ffcc69"}
        action={action}
        onChange={() => onAction()}
        goodsAddRow={recordType == "order_rows_create"}
        goodsAddRowClick={() =>
          setRecordType((prev) =>
            prev == "order_rows" ? "order_rows_create" : "order_rows"
          )
        }
      >
        <span
          className={
            ["order_rows", "order_rows_create"].includes(recordType)
              ? "text-primary text-decoration-underline  mr-2"
              : "text-silver mr-2"
          }
          onClick={() => {
            setRecordType("order_rows");
            if (!action) {
              onAction();
            }
          }}
        >
          Goods
        </span>
      </MiniBlockOrderRowsCustom>
      {action && (
        <div className="bg-silver">
          <OrderRowsComponent
            disabled={disabled}
            order_rows={order_rows}
            order_id={order.id}
            order_shop={order.order_shop}
            information_goods_add={recordType == "order_rows_create"}
            shipping_address_email={shipping_address_email}
          />
        </div>
      )}
    </React.Fragment>
  );
};

const UlElements = styled.ul`
  margin: 0;
  list-style-type: none;
  padding: 0 1px;
  li {
    font-size: 15px;
    color: #000000;
    margin-bottom: 5px;
    word-wrap: break-word;
  }
`;

const Divs = styled.div`
  display: block;
  color: #000000;
  font-size: 15px;
  font-weight: 400;
  & .text-bold {
    font-size: 14px;
    line-height: 20px;
    color: #030303;
    font-weight: 600;
  }
  & .residuesItem {
    font-size: 0.8rem;
    word-wrap: break-word;
  }

  & .orange_color {
    color: #f7951e;
  }
  & .addDoc {
    margin-top: 5px;
    color: #f7951e;
    &:hover {
      color: #bd6903;
      border-bottom: 1px solid #f7951e;
      cursor: pointer;
    }
  }
  & .input_text {
    right: 7%;
    top: 50%;
    font-weight: bold;
    text-transform: uppercase;
    transform: translate(-50%, -50%);
    z-index: 100;
  }
`;

const mapStateToProps = (state, ownProps) => ({
  auth: state.auth,
  documentType: state.documentType.documentType,
  // suppliersItems: state.supplier.suppliers,
  errors: state.errors,
  // ShowIdData
  order_histories: state.orders.order_histories,
  contracts: state.orders.contracts,
  order_rows: state.orders.order_rows,
  payments: state.orders.payments,
  shipments: state.orders.shipments,
  money_refund_items: state.orders.money_refund_items,
  order_documents: state.orders.order_documents,
  order: state.orders.order,
  loading_order: state.orders.loading_order,
  or_quantity_manual: state.orders.or_quantity_manual,
  pickup_addresses: state.options.pickup_addresses,
  ordersShipmentsOver80Kg: state.orders.ordersShipmentsOver80Kg,
  comments_state: ownProps.comments_state || state.comment_state.comments_state || [],
});
export default connect(mapStateToProps, {
  getDocumentType,
  addContract,
  updateContract,
  deleteContractItem,
  deleteContract,
  sendContractEmail,
  createNordrentOrderStatus,
  firstAddContract,
  firstDeleteContract,
  changeContractItems,
  updateSerialNumber,
  updateSerialNumberState,
  postToRivile,
  clearErrors,
  postOrderShipping,
  updateOrderAddress,
  editPayment,
  setCountriesOptions,
})(NordrentOrderShowModal);
